// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".description[data-v-48375b74]{font-size:.7rem;color:#a9a9a9}.spine[data-v-48375b74]{-webkit-animation:spin-48375b74 3s linear infinite;animation:spin-48375b74 3s linear infinite}@-webkit-keyframes spin-48375b74{0%{-webkit-transform:rotate(0);transform:rotate(0)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}@keyframes spin-48375b74{0%{-webkit-transform:rotate(0);transform:rotate(0)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}", ""]);
// Exports
module.exports = exports;
